<script>
/* eslint-disable camelcase */
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Fold, Check, Draggable } from 'he-tree-vue'
import { mapFields } from 'vuex-map-fields'
import createNodeMixin from '../pages/data/createNodeMixin'
export default {
  extends: Tree,
  mixins: [Fold, Check, Draggable, createNodeMixin],
  props: {
    triggerClass: { default: 'drag-trigger' },
    draggable: { type: [Boolean, Function], default: false },
    droppable: { type: [Boolean, Function], default: false },
    node: { required: true, type: Object },
    nodeMap: { required: true, type: Object },
    viewingMode: { required: true, type: Boolean }
  },
  watch: {
    node () {
      this.nodeData = this.node
    },
    editDialog (newValue) {
      // console.log('editDialog changed')
      if (!newValue && !this.selectNodeModeActive) {
        this.$set(this.nodeData, '$active', false)
      }
    }
  },
  data () {
    return {
      nodeData: {},
      treeClass: 'my-tree-view1'
      // nodeRef: {}
      // nodeActive: {},
    }
  },
  computed: {
    ...mapFields('dialogEdit', {
      editDialog: 'editDialog',
      customizeResponseDialog: 'customizeResponseDialog',
      nodePath: 'nodePath',
      typeDialog: 'typeDialog',
      selectNodeModeActive: 'selectNodeMode.active',
      selectNodeModeValue: 'selectNodeMode.value',
      menuJump: 'selectNodeMode.menuJump'
    }),
    ...mapFields('dialogEdit', {
      behavior: 'nodeJumpSelect.behavior',
      dialog_node: 'nodeJumpSelect.dialog_node',
      selector: 'nodeJumpSelect.selector'
    }),
    total () {
      let i = 0
      this.walkTreeData(node => {
        i++
      })
      return i
    },
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    }
  },
  methods: {
    overrideSlotDefault ({ node, index, path, tree }, original) {
      return (
        <md-card
          id={node.data.dialog_node}
          class="node-content drag-trigger before-parent node-card-class"
          style="cursor: pointer; position: relative; width: 700px;"
        >
          <v-row
            no-gutters
            id={this.idActive}
            class={node.$active ? 'card-selected' : ''}
          >
            <v-col
              onClick={() =>
                node.children?.length > 0 ? tree.toggleFold(node, path) : ''
              }
              cols="auto"
              style="align-items: center;"
            >
              <button id="expand-button-id" tabindex="1" class="button-expand">
                {this.returnIcon(node)}
              </button>
            </v-col>
            <v-col cols='auto' onClick={() => this.selectNodeModeActive ? (!node.$active ? this.selectNodeJump(node, path) : '') : this.selectCard(node, path, 'edit')}>
              <v-card v-ripple={this.selectNodeModeActive && !node.$active} style='width: 626px;' flat>
                {this.hasName(node)}
                <v-card-actions>
                  <v-chip-group column active-class="primary--text">
                    {this.isFolder(node)}
                    {this.Jumpto(node)}
                  </v-chip-group>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          {this.dialog_node === node.data.dialog_node ? this.renderJumpMenu(node, path) : ''}
          <md-menu
            md-size="medium"
            md-align-trigger
            style="position: absolute; top: 0; right: 0;"
            class={this.selectNodeModeActive ? 'displayNone' : ''}
          >
            <v-btn
              md-menu-trigger
              style="position: absolute; top: 0; right: 0; margin: 6px 6px 0 0"
              icon
              small
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
            <md-menu-content
              class={this.isNotCheckedOut ? 'disable-click' : ''}
            >
              <md-menu-item
                id={this.dialog_node + 'addChildNode'}
                v-ripple
                onClick={() => {
                  event.stopPropagation()
                  this.$emit('appendNewChild', this.value, node, path)
                }}
              >

                {node.data.type === 'standard' ? this.$t('treeNode.addChildNode') : this.$t('treeNode.addNodeToFolder')}
              </md-menu-item>
              <md-menu-item
                v-ripple
                onClick={() => {
                  event.stopPropagation()
                  this.$emit('addSiblingAbove', { value: this.value, node, path })
                }}
              >
                Adicionar nó acima
              </md-menu-item>
              <md-menu-item
                v-ripple
                onClick={() => {
                  event.stopPropagation()
                  this.$emit('addSiblingBellow', { value: this.value, path })
                }}
              >
                Adicionar nó abaixo
              </md-menu-item>
              <v-divider></v-divider>
              <md-menu-item
                v-ripple
                onClick={() => {
                  event.stopPropagation()
                  this.$emit('duplicate', { value: this.value, node, path })
                }}
              >
                Duplicar
              </md-menu-item>
              <md-menu-item
                v-ripple
                onClick={() => {
                  event.stopPropagation()
                  this.$emit('deleteDialog', { value: this.value, node, path })
                }}
              >
                Remover
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </md-card>
      )
    },
    Jumpto (node) {
      if (node.data?.next_step?.behavior === 'jump_to') {
        return (
          <v-chip color='#3b5998' dark text-color='#ffffff' id='jumpChip' small onClick={() => {
            event.stopPropagation()
            this.scrollToNode(node.data.next_step.dialog_node)
          }}
          >
            <v-icon small left>mdi-logout-variant</v-icon>
            {this.$t('treeNode.jumpTo')}{
              this.nodeMap[node.data.next_step.dialog_node]?.data.title
                ? this.nodeMap[node.data.next_step.dialog_node]?.data.title
                : this.nodeMap[node.data.next_step.dialog_node]?.data.conditions
            }
          </v-chip>
        )
      }
    },
    isFolder (node) {
      if (node.data.type === 'folder') {
        return (
          <v-chip small>
            {node?.children?.length ? this.returnQtyNodesChildren(node)
              : this.$t('treeNode.none')}{' '}
            {node?.children?.length ? this.$t('treeNode.dialogNodes') : this.$t('treeNode.dialogNode')}
          </v-chip>
        )
      }
      return (
        <span>
          <v-chip small>
            {node?.data?.output?.generic?.length ||
              node?.data?.outputResponses?.length ||
              0}{' '}
            {this.$t('treeNode.answers')}
          </v-chip>
          <v-chip small>
            { this.returnContext(node)} {' '}
            {this.$t('treeNode.contextDefined')}
          </v-chip>
        </span>
      )
    },
    returnQtyNodesChildren (node) {
      let count = 0
      node.children.forEach((children) => {
        if (children.data.type === 'standard') {
          count++
        }
      })
      // console.log(count)
      return count
    },
    scrollToNode (id) {
      const node = this.nodeMap[id]
      let parent = node.data.parent
      while (parent) {
        const nodeParent = this.nodeMap[parent]
        nodeParent.$folded = false
        parent = nodeParent.data.parent
      }
      this.$emit('scrollNode', node)
    },
    hasName (node) {
      if (node.data.title) {
        return (
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                {node.data.title}
              </v-list-item-title>
              <v-list-item-subtitle>
                {this.$t('treeNode.ifYouRecognize')} <b>{this.loopAssisRec(node)}</b>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        )
      } else {
        return (
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                {this.loopAssisRec(node)}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        )
      }
    },
    loopAssisRec (node) {
      return node.data.conditions
    },
    selectCard (node, path, type) {
      // console.log(`Select card`, node)
      this.$emit('onNodeClick', { node, path, type })
      this.typeDialog = type
    },
    returnContext (node) {
      if (!node.data?.metadata?._customization?.mcr) { // se não tiver customização de respostas
        if (node.data.context) return Object.keys(node.data.context).length + ' '
        else return '0 '
      } else {
        let customContexts = {}
        for (let i = 0; i < node.data.outputResponses.length; i++) {
          customContexts = { ...customContexts, ...node.data.outputResponses[i].context }
        }
        return Object.keys(customContexts).length + ' '
      }
    },
    loopContexts (node) {
      let count = 0
      for (let i = 0; node.data.outputResponses.length > i; i++) {
        count += Object.keys(node.data.outputResponses[i].context).length
      }
      return count
    },
    returnIcon (node) {
      if (node.data.type === 'folder') {
        if (!(node.children?.length > 0)) {
          return <v-icon color='#fff'>mdi-folder-open-outline</v-icon>
        } else {
          if (node.$folded) {
            return <v-icon color='#fff'>mdi-folder-text</v-icon>
          } else {
            return <v-icon color='#fff'>mdi-folder-open</v-icon>
          }
        }
      } else {
        return node.children?.length > 0 ? (
          <md-icon
            class="icon-expand"
            class={node.$folded ? 'not-expanded' : 'expanded'}
          >
            chevron_right
          </md-icon>
        ) : (
          <md-icon class="icon-expand">remove</md-icon>
        )
      }
    },
    selectNodeJump (node, path) {
      if (node.data.type === 'folder') {
        alert(this.$t('treeNode.itIsNotPossibleToSelectFolderForThisOperation'))
        this.menuJump = false
      } else {
        // console.log('selectNodeJump')
        this.menuJump = false
        // this.nodeRef = node
        this.dialog_node = node.data.dialog_node
        this.menuJump = true
      }
    },
    selectorValue (value, node) {
      this.behavior = 'jump_to'
      this.selector = value
      // console.log(this.behavior)
      // console.log(this.dialog_node)
      // console.log(this.selector)
      this.menuJump = false
      this.editDialog = true
      if (this.selectNodeModeValue === 1) {
        this.customizeResponseDialog = true
      }
      setTimeout(() => {
        this.selectNodeModeActive = false
        this.selectNodeModeValue = 0
      }, 500)
    },
    renderJumpMenu (node, path) {
      return this.menuJump ? <ul class="md-list md-theme-default" style='flex-flow: column;'>
        <li v-ripple class="md-list-item md-menu-item md-theme-default">
          <button
            onClick={() => {
              event.stopPropagation()
              this.selectorValue('user_input', node)
            }}
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
          >
            <div class="md-list-item-content md-ripple">{this.$t('treeNode.waitForUserInput')}</div>
          </button>
        </li>
        <li v-ripple class="md-list-item md-menu-item md-theme-default">
          <button
            onClick={() => {
              event.stopPropagation()
              this.selectorValue('condition', node)
            }}
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
          >
            <div class="md-list-item-content md-ripple">{this.$t('treeNode.ifTheWizardRecognizesCondition')}</div>
          </button>
        </li>
        <li v-ripple class="md-list-item md-menu-item md-theme-default">
          <button
            onClick={() => {
              event.stopPropagation()
              this.selectorValue('body', node)
            }}
            type="button"
            class="md-list-item-button md-list-item-container md-button-clean"
          >
            <div class="md-list-item-content md-ripple">{this.$t('treeNode.reply')}</div>
          </button>
        </li>
      </ul>
        : ''
    },
    setNodeData (nodeData) {
      this.$emit('update:node', nodeData)
    }
  }
}
</script>
<style>
.node-card-class.md-card {
  margin: 6px 0;
}
.before-parent:before {
  content: '';
  display: block;
  border-bottom: 2px solid #8d8d8d;
  border-left: 2px solid #8d8d8d;
  border-bottom-left-radius: 25px;
  width: 22px;
  height: 66px;
  left: -22px;
  top: -6px;
  padding: 0;
  position: absolute;
}
/* .tree-children:before{
  content: '';
  position: absolute;
  display: block;
  border-left: 2px solid #8d8d8d;
  width: 0;
  height: 110%;
  left: -62px;
  top: -2px;
} */
.my-tree-view1
  > .tree-children
  > .tree-branch:not(:last-of-type)
  > .tree-node-back::after {
  content: '';
  position: absolute;
  display: block;
  border-left: 2px solid #8d8d8d;
  width: 0;
  height: 100%;
  left: -22px;
  top: 12px;
}
/* .tree-children>.tree-branch:not(:last-of-type)>.tree-node-back>.tree-node>.md-card::after {
  content: '';
  position: absolute;
  display: block;
  border-left: 2px solid #8d8d8d;
  width: 0;
  height: 105%;
  left: -22px;
  top: 12px;
}
.tree-children>.tree-branch:not(:last-of-type)>.tree-children>.tree-branch>.tree-node-back>.tree-node::after {
  content: '';
  position: absolute;
  display: block;
  border-left: 2px solid #8d8d8d;
  width: 0;
  height: 110%;
  left: -62px;
  top: -2px;
}
.tree-children>.tree-branch:not(:last-of-type)>.tree-children>.tree-branch>.tree-children>.tree-branch::after {
  content: '';
  position: absolute;
  display: block;
  border-left: 2px solid #8d8d8d;
  width: 0;
  height: 110%;
  left: -62px;
  top: -2px;
} */
.tree-branch {
  position: relative;
}
.tree-node {
  position: relative;
}
.button-expand {
  color: white;
  border-radius: 6px 0 0 6px;
  padding: 15px 20px !important;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  border: none;
  cursor: pointer;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  text-align: center;
}
#expand-button-id > .md-icon.md-theme-default.md-icon-font {
  color: white !important;
}
.expanded {
  transform: rotate(90deg) !important;
  transition: 0.2s !important;
}
.not-expanded {
  transform: rotate(0deg) !important;
  transition: 0.2s !important;
}
.card-selected {
  border-radius: 7px;
  border: 2px solid #9c27b0;
  box-shadow: 0px 5px 10px 0px #8d8d8d;
}
.my-tree-view1 {
  position: relative;
}
.my-tree-view1 .mls {
  margin-left: 5px;
}
.my-tree-view1 .mrs {
  margin-right: 5px;
}
.my-tree-view1 .tree-node {
  padding: 0;
  border: none;
}
.my-tree-view1 .node-content {
  display: flex;
}
.my-tree-view1 .node-content .fold-btn {
  display: flex;
  justify-content: center;
  width: 22px;
  border-radius: 100%;
  border: none;
  background: #fcf1a8;
}
.my-tree-view1 .tree-node-back {
  width: 700px;
}
.my-tree-view1 .tree-node-back:hover {
  background: #f5f5f5;
}
.my-tree-view1 .header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
.my-tree-view1 .footer {
  border-top: 1px solid #ccc;
  margin-top: 10px;
}
.disable-click {
  pointer-events: none;
}
.displayNone {
  display: none !important;
}
#jumpChip > .v-chip__content {
  max-width: 220px !important;
  overflow: hidden !important;
  display: block !important;
  text-overflow: ellipsis !important;
  height: 80% !important;
}
</style>
